import ClassNames from "classnames";
import React, { useEffect, useState } from "react";
import LocalizedLink from "../LocalizedLink";

import MobileNav from "./MobileNav";
import MobileLanguageNav from "./MobileLanguageNav";
import * as s from "./s.module.scss";
import SubNav from "./SubNav";
import content from "../../../content/global";
import { getStaticData } from "../../helperFunctions";

import ModalRegular from "../ModalRegular";
import EnquiryForm from "../../partials/Contact/EnquiryForm";
import StaticContent from "../../../content/forms";
import * as s2 from "../../partials/Contact/businessEnquiry.module.scss";
import H, { HeadingType, WeightType } from "../Heading";

import LogoBrand from "../Icons/_Logo/TDCX/LogoBrand";
import Globe from "../Icons/_LineStyle/Globe";

import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MenuOpenContext = React.createContext(() => {});

const Header = ({ data, location, variant, locale }) => {
  const tdcxCN = process.env.GATSBY_BUILD_SITE === "china";

  const [setOpen2] = useState(false);
  const [scrollY, setScrollY] = useState({
    prevValue: 0,
    currentValue: 0,
  });
  const [menuOpen, setMenuOpen] = useState({});

  const subNavServices = getStaticData(content.services_sub_menus, locale);
  const subNav2AiConsulting = getStaticData(
    content.ai_consulting_sub_menus,
    locale
  );

  const subNavIndustries = getStaticData(content.industries_sub_menus, locale);
  const subNavAbout = getStaticData(content.about_sub_menus, locale);
  const subNavMedia = getStaticData(content.media_sub_menus, locale);
  const subNavCareer = getStaticData(content.career_sub_menus, locale);
  const subNavLanguage = getStaticData(content.language_sub_menus, locale);

  const subNav2Insight = getStaticData(content.insights_sub_menus, locale);

  // EnquiryForm-related state variables
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalLanguageIsOpen, setModalLanguageIsOpen] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [responseError, setResponseError] = useState(null);
  const [selectedEnquiryType, setSelectedEnquiryType] = useState({
    value: getStaticData(StaticContent.options, locale)[0].value,
    label: getStaticData(StaticContent.options, locale)[0].label,
  });

  const renderSubNav = (
    data,
    data2,
    title,
    label,
    link,
    icon,
    currentPath,
    languageSwitch = false
  ) => {
    return (
      <SubNav
        data={data}
        data2={data2}
        title={title}
        label={label}
        link={link}
        icon={icon}
        currentPath={currentPath}
        languageSwitch={languageSwitch}
      />
    );
  };

  useEffect(() => {
    let getInTouch = window.location.search;
    if (getInTouch === "?getintouch" && !tdcxCN) {
      setModalIsOpen(true);
    }
  }, [tdcxCN]);

  useEffect(() => {
    const setScrollValue = () => {
      setScrollY({
        prevValue: scrollY.currentValue,
        currentValue: window.pageYOffset,
      });
    };
    window.addEventListener("scroll", setScrollValue);
    return () => {
      window.removeEventListener("scroll", setScrollValue);
    };
  }, [scrollY]);

  useEffect(() => {
    if (scrollY.currentValue >= scrollY.prevValue) {
      if (scrollY.currentValue >= 100) {
        setMenuOpen({});
      }
    }
  }, [scrollY]);

  return (
    <MenuOpenContext.Provider value={{ menuOpen, setMenuOpen }}>
      <>
        {tdcxCN && (
          <div
            className={s.btnFloatContact}
            onClick={() => setModalIsOpen(true)}
          >
            <LocalizedLink
              to={getStaticData(content.consult, locale).link}
              activeClassName={s.active}
            >
              {getStaticData(content.consult, locale).title}
            </LocalizedLink>
          </div>
        )}
        <header className={ClassNames(s.header)}>
          <div
            className={ClassNames(
              s.headerNav,
              locale === "ja" || locale === "jp_ja" ? [s.headerNavJa] : "",
              locale === "zh" || tdcxCN ? [s.headerNavCn] : ""
            )}
          >
            <div className={s.headerNavWrapper}>
              <div className={s.headerNavDrawerToggle}>
                <MobileNav
                  data={data}
                  onGetInTouchClick={() => setOpen2(true)}
                  currentPath={location && location.pathname}
                  locale={locale}
                  setModalIsOpen={setModalIsOpen}
                />
              </div>
              <div className={s.headerNavLogo}>
                <LocalizedLink to="/">
                  <LogoBrand />
                </LocalizedLink>
              </div>
              <div className={s.headerNavMenu}>
                <ul className={s.headerNavMenuLists}>
                  <li className={s.headerNavMenuItem}>
                    {renderSubNav(
                      subNavServices,
                      subNav2AiConsulting,
                      getStaticData(content.services, locale).title,
                      getStaticData(content.services, locale).label,
                      getStaticData(content.services, locale).link,
                      "",
                      location && location.pathname
                    )}
                  </li>
                  <li className={s.headerNavMenuItem}>
                    {renderSubNav(
                      subNavIndustries,
                      "",
                      getStaticData(content.industries, locale).title,
                      getStaticData(content.industries, locale).label,
                      getStaticData(content.industries, locale).link,
                      "",
                      location && location.pathname
                    )}
                  </li>
                  <li className={s.headerNavMenuItem}>
                    {renderSubNav(
                      subNavAbout,
                      "",
                      getStaticData(content.about, locale).title,
                      getStaticData(content.about, locale).label,
                      getStaticData(content.about, locale).link,
                      "",
                      location && location.pathname
                    )}
                  </li>
                  <li className={s.headerNavMenuItem}>
                    {renderSubNav(
                      subNavMedia,
                      subNav2Insight,
                      getStaticData(content.media, locale).title,
                      getStaticData(content.media, locale).label,
                      getStaticData(content.media, locale).link,
                      "",
                      location && location.pathname
                    )}
                  </li>
                  <li className={s.headerNavMenuItem}>
                    {renderSubNav(
                      subNavCareer,
                      "",
                      getStaticData(content.careers, locale).title,
                      getStaticData(content.careers, locale).label,
                      getStaticData(content.careers, locale).link,
                      "",
                      location && location.pathname
                    )}
                  </li>
                </ul>
              </div>
              <div className={s.headerNavRight}>
                <ul className={s.headerNavRightLists}>
                  <li className={s.headerNavCTAItem}>
                    <div
                      className={s.btngetintouch}
                      onClick={() => setModalIsOpen(true)}
                    >
                      <LocalizedLink
                        to={getStaticData(content.boost_your_CX, locale).link}
                        activeClassName={s.active}
                      >
                        {getStaticData(content.boost_your_CX, locale).title}
                      </LocalizedLink>
                    </div>
                  </li>
                  {tdcxCN && (
                    <li className={s.headerNavMenuItem}>
                      <FontAwesomeIcon
                        icon={faPhoneAlt}
                        style={{ marginRight: "5px", color: "#ec5525" }}
                      />
                      <span style={{ color: "#ec5525" }}>+86 4000890200</span>
                    </li>
                  )}
                  {!tdcxCN && (
                    <li
                      className={ClassNames(
                        s.headerNavMenuItem,
                        s.headerNavLanguageBtn
                      )}
                    >
                      {renderSubNav(
                        subNavLanguage,
                        "",
                        "",
                        "",
                        "",
                        <Globe />,
                        location && location.pathname,
                        true
                      )}
                    </li>
                  )}
                </ul>
              </div>
              <div className={s.headerNavLanguageDrawerToggle}>
                <MobileLanguageNav
                  data={data}
                  onGetInTouchClick={() => setOpen2(true)}
                  currentPath={location && location.pathname}
                  locale={locale}
                  setModalLanguageIsOpen={setModalLanguageIsOpen}
                />
              </div>
            </div>
          </div>
          <ModalRegular
            isOpen={modalIsOpen}
            onRequestClose={() => setModalIsOpen(false)}
          >
            <div className={s.modalBody}>
              <div className={s2.header}>
                <div className={s2.title}>
                  <H
                    type={HeadingType.H1}
                    size="h1"
                    weight={WeightType.BOLD}
                    className={s2.text}
                    color="rvGrey500"
                  >
                    {!isSent
                      ? getStaticData(StaticContent.lets_partner_up, locale)
                          .title
                      : getStaticData(StaticContent.we_got_your_message, locale)
                          .title}
                  </H>
                </div>
                <div className={s2.description}>
                  <H
                    type={HeadingType.h5}
                    size="h5"
                    weight={WeightType.REGULAR}
                  >
                    {!isSent
                      ? getStaticData(
                          StaticContent.lets_partner_up_description,
                          locale
                        ).title
                      : getStaticData(
                          StaticContent.get_back_in_two_working_days,
                          locale
                        ).title}
                  </H>
                </div>
              </div>
              {!isSent ? (
                <EnquiryForm
                  featuredContact
                  locale={locale}
                  isSent={isSent}
                  setIsSent={setIsSent}
                  responseError={responseError}
                  setResponseError={setResponseError}
                  selectedEnquiryType={selectedEnquiryType}
                  setSelectedEnquiryType={setSelectedEnquiryType}
                  withRespectedCountry={
                    selectedEnquiryType.value === "JOB" ||
                    selectedEnquiryType.value === "VENDOR"
                  }
                  origin="Header"
                />
              ) : null}
            </div>
          </ModalRegular>
        </header>
      </>
    </MenuOpenContext.Provider>
  );
};
export default Header;
export { MenuOpenContext };
